import { Poppins, Quicksand } from 'next/font/google';
import Image from 'next/image';
import React, { Component } from 'react'
const quickSand = Quicksand({weight:"400",subsets:['latin']});
const popins = Poppins({weight:"500", subsets:['latin']});
const extraPopins = Poppins({weight: "400", subsets: ['latin']});
export default class BlogmainSection extends Component {
  render() {
    const {heading4,heading6,date}=this.props
    return (
      <>
      <section className='details-bg'>
        <div className='container'>
            <div style={{height:"430px"}} className='df fjc fac'>
          <h1 className={`fs-33 mfs-24 cw  ${extraPopins.className}`}>{heading4}</h1>
         
          </div>
          <div className='df fjc fac'>
            
             <h6 className={`fs-20 mfs-12 vec-bg cw tac pdt15`}>{heading6}</h6> 
             <h6 className={`fs-20 mfs-12 cw pdl48 mpdl10 ${popins.className}`}>{date}</h6>
             <div className='pdl16 mpdl5'>
                <Image src={"/blog-imgs/blog-details-img/circle-img.webp"} alt='Circle-icon' width={"16"} height={"16"} loading='lazy'/>
              
             </div>
             <h6 className={`fs-20 mfs-12 cw pdl16 mpdl10 ${popins.className}`}>By Admin</h6>
             </div>
        </div>
      </section>
      {/* <section>
        <div className='container'>
           <h5>ddij</h5>
        </div>
      </section> */}
      <style jsx>
        {`
      .details-bg {

        background-image: url('/course-img/bg-img/course-bg.webp');
        width:100%;
        height: 500px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
  }
        .vec-bg{
            background-image: url("/blog-imgs/blog-details-img/design-vec-bg.webp");
            display: inline-block;
            width: 123px;
            height: 48px;
          
        }
        @media only screen and (max-width: 1023px){
          .vec-bg{
            background-image: url("/blog-imgs/blog-details-img/design-vec-bg.webp");
            display: inline-block;
            width: 73px;
            height: 28px;
          
        } 
        }
        `}
      </style>
      
      </>
    )
  }
}
